import { useEffect, useState } from 'react';
import { isAdminDashboardReady } from './tourElementUtils';

const POLL_MS = 200;
const FALLBACK_MS = 30000;

export function useAdminDashboardReady(active) {
  const [ready, setReady] = useState(() => !active || isAdminDashboardReady());

  useEffect(() => {
    if (!active) {
      setReady(true);
      return undefined;
    }

    if (isAdminDashboardReady()) {
      setReady(true);
      return undefined;
    }

    setReady(false);

    const markReady = () => setReady(true);
    window.addEventListener('admin-dashboard-ready', markReady);

    const poll = setInterval(() => {
      if (isAdminDashboardReady()) {
        markReady();
        clearInterval(poll);
      }
    }, POLL_MS);

    const fallback = setTimeout(markReady, FALLBACK_MS);

    return () => {
      window.removeEventListener('admin-dashboard-ready', markReady);
      clearInterval(poll);
      clearTimeout(fallback);
    };
  }, [active]);

  return ready;
}
